const ITEMS = [
  "THIS HALLOWEEN, WE ALL WIN",
  "NO TRICKS. JUST MEMES.",
  "$HALLOWIN ON SOLANA",
  "PUMPKINS. MEMES. DEGENS.",
  "SPOOKY SEASON NEVER ENDS",
];

export const Marquee = () => (
  <div
    className="relative z-10 border-y border-[#A020F0]/40 bg-[#19002E]/70 backdrop-blur-sm py-4 overflow-hidden marquee-mask"
    data-testid="marquee-strip"
  >
    <div className="flex w-max animate-marquee whitespace-nowrap">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
          {ITEMS.map((item, i) => (
            <span key={i} className="flex items-center mono text-xs sm:text-sm tracking-[0.25em] uppercase">
              <span className={i % 2 === 0 ? "text-[#B6FF00]" : "text-[#FF6B00]"}>{item}</span>
              <span className="mx-8 text-[#A020F0]">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
